module.exports = __webpack_public_path__ + "static/Ginger-39b52ab9852366214446de2e502594dd.jpg";